<template>
  <div class="common-layout" v-if="false">
    <el-container>
      <el-header style="padding:0"><t-header/></el-header>
      <el-container>
        <el-aside width="200px"><sidebar/></el-aside>
        <el-main>
          <div class="content-box" :class="{ 'content-collapse': collapse }">
            <tags/>
            <div class="content">
              <router-view v-slot="{ Component   }">
                <keep-alive>
                  <component :is="Component"/>
                </keep-alive>
              </router-view>
            </div>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
  <div class="about" >
    <t-header/>
    <sidebar/>
    <div class="content-box" :class="{ 'content-collapse': collapse }">
      <tags/>
      <div class="content">
        <router-view v-slot="{ Component   }">
          <keep-alive>
            <component :is="Component"/>
          </keep-alive>
        </router-view>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import THeader from "@/components/Header.vue";
import Sidebar from "@/components/Sidebar.vue";
import Tags from "@/components/Tags.vue";
import {computed} from "vue";
import store from "@/store";
const collapse = computed(() => {
  return store.state.collapse;
})
</script>
<style>
.content-collapse {
  left: 1px;
}

</style>